import { apiRequest } from '../utils/api';

export const submitSubjectSuggestion = (payload) =>
  apiRequest(
    '/api/v1/subject-suggestions',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
    {
      // A POST should not be retried automatically unless the backend
      // supports an idempotency key.
      maxRetries: 0,
    },
  );

export const getAdminSubjectSuggestions = ({
  status = 'pending',
  page = 1,
  limit = 100,
} = {}) => {
  const params = new URLSearchParams({
    status,
    page: String(page),
    limit: String(limit),
  });
  return apiRequest(`/api/v1/subject-suggestions/admin?${params.toString()}`);
};

export const approveSubjectSuggestion = (suggestionId) =>
  apiRequest(
    `/api/v1/subject-suggestions/${suggestionId}/approve`,
    { method: 'PATCH' },
    { maxRetries: 0 },
  );

export const rejectSubjectSuggestion = (suggestionId, reason) =>
  apiRequest(
    `/api/v1/subject-suggestions/${suggestionId}/reject`,
    {
      method: 'PATCH',
      body: JSON.stringify({ reason }),
    },
    { maxRetries: 0 },
  );
